module.exports = __webpack_public_path__ + "static/mask_lo_108-cfa577818bc4edbb26b51caa9b5ccf78.jpg";